import { BASE_API_URL } from './index';

export const baseDataEndpoint = `${BASE_API_URL}/data`;

export const getBankNameFromRoutingNumber = (routingNumber) =>
  `${baseDataEndpoint}/funding/routing_numbers/${routingNumber}/`;

export const itemStructureDataEndpoint = `${baseDataEndpoint}/item/item_structure/`;
